/* __next_internal_client_entry_do_not_use__ RenderSuppliersRoutes auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { Route as UnknownRoute } from "@faire/web--source/ui/routing/Route";
import React from "react";
import { SuppliersRouter } from "@faire/retailer/views/suppliers/SuppliersRouter";
export var RenderSuppliersRoutes = function() {
    return /*#__PURE__*/ _jsx(UnknownRoute, {
        path: "/suppliers",
        component: SuppliersRouter
    });
};
